import { APP_BUILD_CHANNEL, APP_BUILD_TIME, APP_VERSION } from '@/constants/version';
import { DebugKv, DebugSection } from '../DebugSection';

export interface EnvironmentSectionProps { searchTerm?: string }

export function EnvironmentSection({ searchTerm }: EnvironmentSectionProps): JSX.Element {
  const rows: Array<{ k: string; v: unknown }> = [
    { k: 'APP_VERSION', v: APP_VERSION },
    { k: 'APP_BUILD_TIME', v: APP_BUILD_TIME },
    { k: 'APP_BUILD_CHANNEL', v: APP_BUILD_CHANNEL },
    { k: 'vite.MODE', v: import.meta.env.MODE },
    { k: 'vite.DEV', v: import.meta.env.DEV },
    { k: 'vite.PROD', v: import.meta.env.PROD },
  ];

  if (typeof navigator !== 'undefined') {
    rows.push({ k: 'userAgent', v: navigator.userAgent });
    rows.push({ k: 'platform', v: navigator.platform });
    rows.push({ k: 'language', v: navigator.language });
    rows.push({ k: 'maxTouchPoints', v: navigator.maxTouchPoints });
    rows.push({ k: 'onLine', v: navigator.onLine });
  }
  if (typeof window !== 'undefined') {
    rows.push({ k: 'viewport.innerWidth', v: window.innerWidth });
    rows.push({ k: 'viewport.innerHeight', v: window.innerHeight });
    rows.push({ k: 'devicePixelRatio', v: window.devicePixelRatio });
    try {
      rows.push({ k: 'colorScheme', v: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' });
      rows.push({ k: 'reducedMotion', v: window.matchMedia('(prefers-reduced-motion: reduce)').matches });
      rows.push({ k: 'locale', v: Intl.DateTimeFormat().resolvedOptions().locale });
      rows.push({ k: 'timezone', v: Intl.DateTimeFormat().resolvedOptions().timeZone });
    } catch { /* ignore */ }
  }

  return (
    <DebugSection id="environment" title="11. Environment + build" searchTerm={searchTerm}>
      <DebugKv rows={rows} searchTerm={searchTerm} />
    </DebugSection>
  );
}
